"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { reloadServingBuild } from "@/lib/chunk-load-recovery";

export function LoadFailureDialog({
  title,
  open,
  onOpenChange,
}: {
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>Refresh to try again.</DialogDescription>
        <Button variant="primary" onClick={reloadServingBuild}>
          Refresh page
        </Button>
      </DialogContent>
    </Dialog>
  );
}
